import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faMoneyBill,
  faTimesCircle,
  faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons';
import { DealModel } from 'ts/package/interfaces/PackageOfflineResponse';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface PackageInfoProps {
  deal: DealModel;
}

const PackageInfo: FC<PackageInfoProps> = ({ deal: { package: pac } }) => {
  const [t] = useTranslation();

  return (
    <div className="default-shadow flight-details-item">
      <div className="title-underline text-lg mb-15">{t('details')}</div>
      {!!pac.descLangs.length && (
        <div dangerouslySetInnerHTML={{ __html: pac.descLangs[0].desc }}></div>
      )}
      <div className="divider mt-20 mb-20"></div>
      {!!pac.listOfIncludeInfoLangs?.length &&
        !!pac.listOfIncludeInfoLangs?.[0]?.listOfDesc?.length && (
          <div className="mb-20">
            <div className="title">
              <FontAwesomeIcon icon={faCheckCircle} className="text-success" />
              <span className="ml-5">{t('package.including')}</span>
            </div>
            {pac.listOfIncludeInfoLangs.map((item, index) => (
              <div key={index} className="ml-28">
                {item.listOfDesc.map((row, rowIndex) => (
                  <div key={rowIndex}>{row.name}</div>
                ))}
              </div>
            ))}
          </div>
        )}

      {!!pac.listOfIncludeInfoLangs?.length &&
        !!pac.listOfIncludeInfoLangs?.[0]?.listOfDesc?.length && (
          <div className="mb-20">
            <div className="title">
              <FontAwesomeIcon icon={faTimesCircle} className="color-danger" />
              <span className="ml-5">{t('package.not_including')}</span>
            </div>
            {pac.listOfNotIncludeInfoLangs.map((item, index) => (
              <div key={index} className="ml-28">
                {item.listOfDesc.map((row, rowIndex) => (
                  <div key={rowIndex}>{row.name}</div>
                ))}
              </div>
            ))}
          </div>
        )}

      {!!pac.listOfInformationLangs?.length &&
        !!pac.listOfInformationLangs?.[0]?.listOfDesc?.length && (
          <div className="mb-20">
            <div className="title">
              <FontAwesomeIcon icon={faTriangleExclamation} className="text-warning" />
              <span className="ml-5">{t('package.more_info')}</span>
            </div>
            {pac.listOfInformationLangs.map((item, index) => (
              <div key={index} className="ml-28">
                {item.listOfDesc.map((row, rowIndex) => (
                  <div key={rowIndex}>{row.name}</div>
                ))}
              </div>
            ))}
          </div>
        )}

      {!!pac.listOfInformationLangs?.length &&
        !!pac.listOfInformationLangs?.[0]?.listOfDesc?.length && (
          <div className="mb-20">
            <div className="title">
              <FontAwesomeIcon icon={faMoneyBill} className="color-danger" />
              <span className="ml-5">{t('package.terms_of_cancellation')}</span>
            </div>
            {pac.listOfPackageCancellationInfoLangs.map((item, index) => (
              <div key={index} className="ml-28">
                {item.listOfDesc.map((row, rowIndex) => (
                  <div key={rowIndex}>{row.name}</div>
                ))}
              </div>
            ))}
          </div>
        )}
    </div>
  );
};

export default withErrorBoundary(PackageInfo, 'PackageInfo');
